<panel width="600">
	<h1>{{ 'sale.approve-order.header' | translate }}</h1>
	<section>
		@if (questionnaireId) {
			<questionnaire #questionnaire
						   [questionnaireId]="questionnaireId"
						   [orderLines]="orderLines"
						   [showCategoryDetails]="false"
						   [displayAsForm]="true"
						   [editable]="true" />
		}
	</section>
	<section>
		<button confirm [ignoreValidation]="true" [active]="questionnaire?.areRequiredQuestionsAnswered()" (click)="approveOrder()">{{ 'sale.approve' | translate }}</button>
	</section>
</panel>
